  
 
  <form  [formGroup]="formDialog">
    <h2 mat-dialog-title>
        Add Note Type
        <button mat-icon-button (click)="closeAddTouchType()">
        <mat-icon>close</mat-icon>
        </button>
    </h2>
    
  <mat-dialog-content class="mat-typography">
    <mat-form-field class="example-full-width">
        <mat-label>Note Type</mat-label>
        <input matInput maxlength="50"  [required]="true"  placeholder="Add note type" formControlName="touchTypeName"
        (input)="onSearchChange($event.target.value)"/>
        <mat-error
        *ngIf="formDialog.get('touchTypeName').invalid &&
          (formDialog.get('touchTypeName').dirty ||
          formDialog.get('touchTypeName').touched)">
        <span>This field is mandatory.</span>
      </mat-error>
      </mat-form-field> 
  
  </mat-dialog-content>
  

  <div class="tabContainer">
    <div class="d-flex">       
    
        <div class="template-holder">
         
         <div class="right">                   
                       
           <div class="list">
    
            <div class="tempalteList">
              <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundStatus">
                <tr>
                  <th>Note Name</th>             
                  <th class="actBtn">Action</th>
                </tr>
                <tr *ngFor="let data of activityNameList"
                  [ngClass]="{ 'active': data.touchTypeID === selectedtouchTypeID}">
    
                  <td class="formName" style="cursor: pointer;" (click)="SelectStatus(data)">
                    {{data.touchName}}
                  </td>            
    
                  <td>
                    <button mat-button color="primary" (click)="SelectStatus(data)">Select</button>                           
                  </td>
                </tr>

              </table>
              <div *ngIf="ShowNoRecordFoundStatus" class="noRecordFound">No Record Found</div>
            </div>
    
           </div>
      
         </div>
      </div>  

    </div>
 
  </div>  

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="closeAddTouchType()">Cancel</button>
    <button mat-flat-button color="primary"    
    [disabled]="formDialog.invalid || !formDialog.dirty"
    (click)="AddTouchTypeName(formDialog.value)">Save
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
  </mat-dialog-actions>
  
    </form>
  

  




